import { getMap } from './mapInstance.js';
import { deactivateDragZoom } from './Magnify.js';
import DragPan from 'ol/interaction/DragPan';
import { setMapCursor } from './mapUtils.js';
import { setActiveSidebarTool, setSidebarToolActive } from './dialogs.js';
import { resetActiveCommandsOnly } from './resetApplication.js';

let dragPanInteraction = null;

/**
 * Activates panning mode and disables zoom by box
 */
export function activatePanMode() {

  const map = getMap();
  if (!map) return;

  resetActiveCommandsOnly();
  deactivateDragZoom(); // this now works
  if (dragPanInteraction) {
    map.removeInteraction(dragPanInteraction);
  }

  dragPanInteraction = new DragPan();
  map.addInteraction(dragPanInteraction);

  setMapCursor('grab'); //hand cursor
  setActiveSidebarTool('.pan-button', { lock: true });
}

export function deactivatePanMode() {

  const map = getMap();
  if (!map) return;

  if (dragPanInteraction) {
    map.removeInteraction(dragPanInteraction);
    dragPanInteraction = null;
    setMapCursor('default');
    setSidebarToolActive('.pan-button', false);

  }
}

document.addEventListener('application-reset-active-tools', () => {
  deactivatePanMode();
});
